<template>
  <div id="comparative">
    <v-container fluid style="max-width: 99% !important;">
      <v-row align="center">
        <v-col lg="12">
          <v-card v-if="viewSkeletonsC" :color="whitesmoke">
            <v-col cols="12">
              <div :class="skeletonTitleC" :style="backgroundSkeleton"></div>
            </v-col>
            <v-col cols="12">
              <div
                :class="skeletonColumnC"
                :style="backgroundSkeleton + 'height: 150px !important;'"
              ></div>
            </v-col>
          </v-card>
          <v-card height="100%" v-else>
            <v-card-title class="headline" style="font-size: 20px !important;">{{ "GENERAL" }}</v-card-title>
            <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
            <v-card-text>
              <v-container style="padding:0">
                <v-row class="mb-6" no-gutters style="margin-bottom: 0px !important;">
                  <v-col sm="12" lg="3" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row
                        class="mb-6"
                        no-gutters
                        style="margin-bottom: 5px!important;font-size: 16px;"
                      >{{ $t("vehicle") }}</v-row>
                      <v-row class="mb-6" no-gutters style="margin-bottom: 5px!important;">
                        <v-icon :color="colorTheme" style="padding-right: 8px;">mdi-truck</v-icon>
                        {{ nickId + " (" + vehicleId + ")" }}
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col sm="12" lg="3" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row
                        class="mb-6"
                        no-gutters
                        style="margin-bottom: 5px!important;font-size: 16px;"
                      >{{ $t("periodTitle") }}</v-row>
                      <v-row class="mb-6" no-gutters style="margin-bottom: 5px!important;">
                        <v-icon :color="colorTheme" style="padding-right: 8px;">mdi-calendar</v-icon>
                        {{ startDate + " " + $t("to") + " " + endDate }}
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col sm="12" lg="1" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row
                        class="mb-6"
                        no-gutters
                        style="margin-bottom: 5px!important;font-size: 16px;"
                      >{{ $t("travels") }}</v-row>
                      <v-row class="mb-6" no-gutters style="margin-bottom: 5px!important;">
                        <v-icon :color="colorTheme" style="padding-right: 8px;">mdi-routes</v-icon>
                        {{ numberOfTrips }}
                      </v-row>
                    </v-card>
                  </v-col>

                  <v-col sm="12" lg="2" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row
                        class="mb-6"
                        no-gutters
                        style="margin-bottom: 5px!important;font-size: 16px;"
                      >{{ $t("finalOdometer") }}</v-row>
                      <v-row class="mb-6" no-gutters style="margin-bottom: 5px!important;">
                        <v-icon :color="colorTheme" style="padding-right: 8px;">mdi-speedometer</v-icon>
                        {{ finalOdometer }}
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col sm="12" lg="2" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row
                        class="mb-6"
                        no-gutters
                        style="margin-bottom: 5px!important;font-size: 16px;"
                      >{{ $t("finalFuel") }}</v-row>
                      <v-row class="mb-6" no-gutters style="margin-bottom: 5px!important;">
                        <v-icon :color="colorTheme" style="padding-right: 8px;">mdi-gas-station</v-icon>
                        {{ finalFuel }}
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12" lg="2" md="6" xs="12" cols="12">
                    <v-row no-gutters>
                      <v-col sm="12" lg="6" md="6" xs="12" cols="12">
                        <v-card class="pa-2" tile :style="styleCard + 'display: flex;'">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :color="colorTheme"
                                dark
                                :style="'height: 40px;width: 50px;margin-right: 15px;'"
                                v-on:click="toExcelData()"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon rigth dark style>mdi-file-excel</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t("expExcel").toUpperCase() }}</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :color="colorTheme"
                                dark
                                :style="'height: 40px;width: 50px;margin-right: 15px;'"
                                v-on:click="printDashboard()"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon rigth dark style>mdi-image-area</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t("expDash").toUpperCase() }}</span>
                          </v-tooltip>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" style="text-align: start;">{{ $t("calGlobal").toUpperCase() }}</v-col>
        <v-col lg="12" md="12" sm="12">
          <v-data-table
            :no-data-text="$t('noResults')"
            :headers="headersGlobalCalculations"
            :items="itemsGlobalCalc"
            :items-per-page="5"
            :loading="progressC"
            :loading-text="$t('loadingTextForTable')"
            class="elevation-1 tableIntransit"
            sort-by="distancRoad"
            :footer-props="{
              'items-per-page-text': $t('rows'),
              'items-per-page-all-text': $t('all')
            }"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.trip }}</td>
              <td class="text-xs-center">{{ props.item.performance }}</td>
              <td class="text-xs-center">{{ props.item.distancRoad }}</td>
              <td class="text-xs-center">{{ props.item.timeEngine }}</td>
              <td class="text-xs-center">{{ props.item.breakTime }}</td>
              <td class="text-xs-center">{{ props.item.fuelConsumed }}</td>
              <td class="text-xs-center">{{ props.item.tripDuration }}</td>
              <td class="text-xs-center">{{ props.item.exceptions }}</td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="mdi-alert"
            >{{ $t("noResults") }} : "{{ search }}".</v-alert>
            <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
          </v-data-table>
        </v-col>
        <v-col cols="12" xs="12" style="text-align: start;">{{ $t("efficiency").toUpperCase() }}</v-col>

        <v-col cols="12" xs="12">
          <v-row>
            <v-col sm="12" lg="6" md="6" xs="12" cols="12">
              <v-card v-if="viewSkeletonsC" :color="whitesmoke">
                <v-col cols="12">
                  <div :class="skeletonTitleC" :style="backgroundSkeleton"></div>
                </v-col>
                <v-col cols="12">
                  <div :class="skeletonColumnC" :style="backgroundSkeleton"></div>
                </v-col>
              </v-card>
              <v-card>
                <div id="comparative1"></div>
              </v-card>
            </v-col>

            <v-col sm="12" lg="6" md="6" xs="12" cols="12">
              <v-card v-if="viewSkeletonsC" :color="whitesmoke">
                <v-col cols="12">
                  <div :class="skeletonTitleC" :style="backgroundSkeleton"></div>
                </v-col>
                <v-col cols="12">
                  <div :class="skeletonColumnC" :style="backgroundSkeleton"></div>
                </v-col>
              </v-card>
              <v-card>
                <div id="comparative2"></div>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" lg="4" md="4" xs="12" cols="12">
              <v-card v-if="viewSkeletonsC" :color="whitesmoke">
                <v-col cols="12">
                  <div :class="skeletonTitleC" :style="backgroundSkeleton"></div>
                </v-col>
                <v-col cols="12">
                  <div :class="skeletonColumnC" :style="backgroundSkeleton"></div>
                </v-col>
              </v-card>
              <v-card>
                <div id="comparative3"></div>
              </v-card>
            </v-col>

            <v-col sm="12" lg="8" md="8" xs="12" cols="12">
              <v-card v-if="viewSkeletonsC" :color="whitesmoke">
                <v-col cols="12">
                  <div :class="skeletonTitleC" :style="backgroundSkeleton"></div>
                </v-col>
                <v-col cols="12">
                  <div :class="skeletonColumnC" :style="backgroundSkeleton"></div>
                </v-col>
              </v-card>
              <v-card>
                <div id="comparative4"></div>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col sm="12" lg="4" md="4" xs="12" cols="12">
              <v-card v-if="viewSkeletonsC" :color="whitesmoke">
                <v-col cols="12">
                  <div :class="skeletonTitleC" :style="backgroundSkeleton"></div>
                </v-col>
                <v-col cols="12">
                  <div :class="skeletonColumnC" :style="backgroundSkeleton"></div>
                </v-col>
              </v-card>
              <v-card>
                <div id="comparative5"></div>
              </v-card>
            </v-col>
            <v-col sm="12" lg="4" md="4" xs="12" cols="12">
              <v-card v-if="viewSkeletonsC" :color="whitesmoke">
                <v-col cols="12">
                  <div :class="skeletonTitleC" :style="backgroundSkeleton"></div>
                </v-col>
                <v-col cols="12">
                  <div :class="skeletonColumnC" :style="backgroundSkeleton"></div>
                </v-col>
              </v-card>
              <v-card>
                <div id="comparative6"></div>
              </v-card>
            </v-col>
            <v-col sm="12" lg="4" md="4" xs="12" cols="12">
              <v-card v-if="viewSkeletonsC" :color="whitesmoke">
                <v-col cols="12">
                  <div :class="skeletonTitleC" :style="backgroundSkeleton"></div>
                </v-col>
                <v-col cols="12">
                  <div :class="skeletonColumnC" :style="backgroundSkeleton"></div>
                </v-col>
              </v-card>
              <v-card>
                <div id="comparative7"></div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" xs="12" style="text-align: start;">{{ $t("tripAnalysis").toUpperCase() }}</v-col>
        <v-col lg="12" md="12" sm="12">
          <v-data-table
            :no-data-text="$t('noResults')"
            :headers="headersTripsAnalysis"
            :items="itemsTripsAnalysis"
            :search="search"
            :items-per-page="5"
            :loading="progressC"
            :loading-text="$t('loadingTextForTable')"
            class="elevation-1 tableIntransit"
            sort-by="minSpeed"
            :footer-props="{
              'items-per-page-text': $t('rows'),
              'items-per-page-all-text': $t('all')
            }"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.trip }}</td>
              <td class="text-xs-center">{{ props.item.maxSpeed }}</td>
              <td class="text-xs-center">{{ props.item.avgSpeed }}</td>
              <td class="text-xs-center">{{ props.item.maxRpmm }}</td>
              <td class="text-xs-center">{{ props.item.rpmAvg }}</td>
              <td class="text-xs-center">{{ props.item.AvgMotorLoad }}</td>
              <td class="text-xs-center">{{ props.item.pedalProm }}</td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="mdi-alert"
            >{{ $t("noResults") }} : "{{ search }}".</v-alert>
            <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
          </v-data-table>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          style="text-align: start;"
        >{{ $t("tripInTransitIncidents").toUpperCase() }}</v-col>

        <v-col cols="12" xs="12" style="text-align: start;">
          <v-row>
            <v-col sm="12" lg="12" md="12" xs="12" cols="12">
              <v-card>
                <div id="comparative8"></div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" xs="12" style="text-align: start;">{{ $t("distribution").toUpperCase() }}</v-col>
        <v-col lg="12" md="12" sm="12" v-if="!print">
          <v-card :color="whitesmoke" v-if="viewSkeletonsC">
            <v-col cols="12">
              <div :class="skeletonTitleC" :style="backgroundSkeleton"></div>
            </v-col>
            <v-col cols="12">
              <div
                :class="skeletonColumnC"
                :style="backgroundSkeleton + 'height: 590px !important;'"
              ></div>
            </v-col>
          </v-card>
          <v-card v-else>
            <v-card-title class="headline" :style="fontsizecard">
              {{
              $t("titleExceptions")
              }}
            </v-card-title>
            <div id="mapComparative" style="width: 100%; height: 590px"></div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import Highcharts from "highcharts";
import domtoimage from "dom-to-image";
import MarkerClusterer from "@googlemaps/markerclustererplus";

export default {
  name: "comparative",
  components: {
    highcharts: Chart
  },
  data() {
    return {
      styleCard: " -webkit-box-shadow: none;box-shadow: none;",
      rowStyle: "margin-bottom: 5px!important;",
      vehicleId: "",
      nickId: "",
      startDate: "",
      endDate: "",
      tripsNumber: "",
      print: false
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("skeletonC", "outskeleton");
    this.$store.commit("skeletonTitleC", "outskeletonTitle");
    this.$store.commit("skeletonPieC", "outskeletonPie");
    this.$store.commit("skeletonFooterC", "outskeletonFooter");
    this.$store.commit("skeletonColumnC", "outskeletonColumn");
    var myTitle = JSON.parse(localStorage.getItem("mytitle"));
    if (this.$store.state.titleGraphic == "") {
      this.$store.commit("titleOfGraphic", myTitle);
    }
    this.$store.commit("setPageHeader", [
      this.$t("dashboard"),
      this.$store.state.PageHeaderGraphTitle.toUpperCase(),
      this.$t("performance"),
      this.$t("comparative"),
      true
    ]);
    this.$store.commit("changeHeadersCompare");
  },
  async mounted() {
    var ItemsPerformance = this.$store.state.itemsPerformanceInfo;
    this.$store.commit("viewSkeletonsC", true);
    this.$store.commit("progressComparative", true);
    if (ItemsPerformance == null) {
      ItemsPerformance = await this.$store.dispatch(
        "getItemPouchdb",
        "ItemsPerformance"
      );
    }

    this.$store.commit("backgroundSkeleton");
    this.general();

    this.$store.dispatch("divideData", {
      itemsPerformance1: ItemsPerformance,
      comparative: true,
      byTrip: false
    });
  },
  watch: {},
  computed: {
    ...mapState([
      "colorTheme",
      "backgroundSkeleton",
      "whitesmoke",
      "fontsizecard",
      "fontsizesub",
      "viewSkeletonsP",
      "headersPerformance",
      "itemsTableInTransit",
      "headersGlobalCalculations",
      "itemsGlobalCalc",
      "headersTripsAnalysis",
      "itemsTripsAnalysis",
      "numberOfTrips",
      "finalOdometer",
      "finalFuel",
      "progressC",
      "viewSkeletonsC"
    ]),
    skeletonC: {
      get: function() {
        return this.$store.state.skeletonC;
      },
      set: function() {}
    },
    skeletonTitleC: {
      get: function() {
        return this.$store.state.skeletonTitleC;
      },
      set: function() {}
    },
    skeletonPieC: {
      get: function() {
        return this.$store.state.skeletonPieC;
      },
      set: function() {}
    },
    skeletonFooterC: {
      get: function() {
        return this.$store.state.skeletonFooterC;
      },
      set: function() {}
    },
    skeletonColumnC: {
      get: function() {
        return this.$store.state.skeletonColumnC;
      },
      set: function() {}
    }
  },
  methods: {
    async toExcelData() {
      var ItemsPerformance = this.$store.state.itemsPerformanceInfo;
      if (ItemsPerformance == null) {
        ItemsPerformance = await this.$store.dispatch(
          "getItemPouchdb",
          "ItemsPerformance"
        );
      }
      this.$store.dispatch("downloadExcelJson", ItemsPerformance);
    },
    general() {
      var vehicle = localStorage.getItem("performanceVehicle");
      vehicle = vehicle.split("@");
      this.nickId = vehicle[0];
      this.vehicleId = vehicle[1];
      var sDate = localStorage.getItem("datesCalendar1");
      var eDate = localStorage.getItem("datesCalendar2");
      var sClock = localStorage.getItem("startClock");
      var eClock = localStorage.getItem("endClock");
      sClock = sClock == undefined || sClock.length == 0 ? " 00:00" : sClock;
      this.startDate = sDate + " " + sClock;
      this.endDate =
        eDate == undefined || eDate.length == 0
          ? sDate + " 23:59"
          : eDate + " " + eClock;

      this.startDate = this.$store.getters.formatDateCustom(this.startDate);
      this.endDate = this.$store.getters.formatDateCustom(this.endDate);
      this.tripsNumber = this.$store.state.listOfTrips.length - 1;
    },
    printDashboard() {
      var vm = this;
      this.print = true;

      var vehicle = this.nickId;
      var node = document.getElementById("comparative");
      // console.log(node);
      domtoimage.toBlob(node).then(function(blob) {
        window.saveAs(blob, "AT-Comparative." + vehicle + ".png");
        vm.print = false;
      });
    }
  }
};
</script>

<style>
@import "./../assets/styles/skeletons.css";
</style>
